<template>
  <!-- 基本信息 -->
  <el-row :gutter="12" class="page" :style="{filter: this.$store.state.isVague?'blur(2px)':''}">
    <el-col :span="8" class="distribution">
      <div class="grid-content record">
        <div class="generalBg_Virtualization"></div>
        <div class="dataSources">
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span style="margin-right:20px;">专业基本信息</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <!-- 内容 -->
          <div class="standards_content">
            <div class="project-box" style="padding:15px 10px 15px 15px;height: calc(100% - 30px);">
              <el-row>
                <div class="mr-2 mt-2 custom-tag">专业名称</div>
                <div class="mr-2 mt-2 custom-tag">
                  <el-tooltip class="item" effect="dark" :content="information.majorName" placement="bottom">
                    <span>{{information.majorName}}</span>
                  </el-tooltip>
                </div>
                <div class="mr-2 mt-2 custom-tag">所属专业大类</div>
                <div class="mr-2 mt-2 custom-tag">
                  <el-tooltip class="item" effect="dark" :content="information.bigMajorName" placement="bottom">
                    <span>{{information.bigMajorName}}</span>
                  </el-tooltip>
                </div>
              </el-row>
              <el-row>
                <div class="mr-2 mt-2 custom-tag">所属专业类</div>
                <div class="mr-2 mt-2 custom-tag">
                  <el-tooltip class="item" effect="dark" :content="information.wellMajorName" placement="bottom">
                    <span>{{information.wellMajorName}}</span>
                  </el-tooltip>
                </div>
                <div class="mr-2 mt-2 custom-tag">专业代码</div>
                <div class="mr-2 mt-2 custom-tag">
                  <el-tooltip class="item" effect="dark" :content="information.majorCode" placement="bottom">
                    <span>{{information.majorCode}}</span>
                  </el-tooltip>
                </div>
              </el-row>
              <el-row>
                <div class="mr-2 mt-2 custom-tag">专业层次</div>
                <div class="mr-2 mt-2 custom-tag">
                  <el-tooltip class="item" effect="dark" :content="information.majorLevel" placement="bottom">
                    <span>{{information.majorLevel == '1'?'中职':information.majorLevel == '2'?'高职':information.majorLevel == '3'?'职教本科':''}}</span>
                  </el-tooltip>
                </div>
                <div class="mr-2 mt-2 custom-tag">专业年限</div>
                <div class="mr-2 mt-2 custom-tag">
                  <span>{{information.years}}</span>
                </div>
              </el-row>
              <!-- <el-row>
                <div class="mr-2 mt-2 custom-tag">所属产业大类</div>
                <div class="mr-2 mt-2 custom-tag">
                  <el-tooltip class="item" effect="dark" :content="information.industryBigClass" placement="bottom">
                    <span>{{information.industryBigClass}}</span>
                  </el-tooltip>
                </div>
                <div class="mr-2 mt-2 custom-tag">所属产业类</div>
                <div class="mr-2 mt-2 custom-tag">
                  <el-tooltip class="item" effect="dark" :content="information.industryClass" placement="bottom">
                    <span>{{information.industryClass}}</span>
                  </el-tooltip>
                </div>
              </el-row> -->
              <el-row>
                <div class="mr-2 mt-2 custom-tag">衔接中职专业</div>
                <div class="mr-2 mt-2 custom-tag">
                  <el-tooltip class="item" effect="dark" :content="information.connectIntermediate" placement="bottom">
                    <span>{{information.connectIntermediate}}</span>
                  </el-tooltip>
                </div>
                <div class="mr-2 mt-2 custom-tag">衔接本科专业</div>
                <div class="mr-2 mt-2 custom-tag">
                  <el-tooltip class="item" effect="dark" :content="information.connectUndergraduate" placement="bottom">
                    <span>{{information.connectUndergraduate}}</span>
                  </el-tooltip>
                </div>
              </el-row>
              <!-- <p class="grey size14 indent mt-30">
                  {{information.professionDescript}}
                </p> -->
            </div>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :span="16" class="distribution">
      <div class="grid-content record">
        <div class="generalBg_Virtualization"></div>
        <div class="dataSources">
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span style="margin-right:20px;">培养目标</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content">
            <div class="tag-box">
              <div class="grey size14 lineHeight">
                {{information.trainingObjectives}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :span="8" class="distribution middle">
      <div class="grid-content record">
        <div class="generalBg_Virtualization"></div>
        <div class="dataSources">
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span style="margin-right:20px;">可从事岗位</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content">
            <div class="tag-box">
              <el-tag class="mr-10 mt-10 size14" v-for="(item,index) in information.professionalFace" :key="index">{{item.replaceAll('。','')}}</el-tag>
            </div>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :span="16" class="distribution middle">
      <div class="grid-content record">
        <div class="generalBg_Virtualization"></div>
        <div class="dataSources">
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span style="margin-right:20px;">专业资源库</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content">
            <el-carousel :interval="5000" :autoplay='false' arrow="never" height="100%" ref="rotation">
              <el-carousel-item v-for="(item,index) in resourceLibrary" :key="index">
                <div class="rotationLayout" v-for="(e,i) in item.childrenList" :key="i">
                  <div class="smallBox pointer" @click="jump(e.url)">
                    <div class="casket" :class="e.series === '国家级'?'nationalLevel':e.series === '省级'?'provincialLevel':'schoolLevel'">
                      <span>{{e.libraryName}}</span>
                    </div>
                    <div class="mainInformation">
                      <dl>
                        <dt>{{e.libraryName}}</dt>
                        <dd v-show="false">
                          综合排名：<span>{{e.ranking}}名</span>
                          <div class="ascend">
                            <i class="u_arrow rise" v-if="e.isRise"></i>
                            <i class="d_arrow decline" v-else></i>
                            <span class="risea" v-if="e.isRise">上升100名</span>
                            <span class="declinea" v-else>下降100名</span>
                          </div>
                        </dd>
                        <dd>主持院校：<span>{{e.colleges}}</span></dd>
                        <dd>立项时间：<span>{{e.year}}年</span></dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="toggleArrowLeft" @click="toggleUpper">
              <i class="icona icon-leftSwitch"></i>
            </div>
            <div class="toggleArrowRight" @click="toggleLower">
              <i class="icona icon-rightSwitch"></i>
            </div>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :span="24" class="occupation">
      <div class="grid-content record">
        <div class="generalBg_Virtualization"></div>
        <div class="dataSources">
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span style="margin-right:20px;">专业证书</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content">
            <div class="table-search-box">
              <el-form :inline="true" :model="formInSearch" class="demo-form-inline">
                <!-- 防止输入框回车刷新页面 -->
                <el-form-item label="" v-show="false">
                  <el-input size="small"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" v-model="formInSearch.certificateNameBody" placeholder="请输入证书名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <div class="search_button">
                    <i class="pointer el-icon-search" @click="certificateDom"></i>
                    <i class="pointer el-icon-refresh-left" @click="formInSearch.certificateNameBody = '',certificateDom()"></i>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="certificate_box">
              <div class="professional_box" v-for="(item,index) in certificateList" :key="index">
                <div class="professional_smallBox pointer" @click="downloads(item.fileId,item.certificateName)">
                  <div class="credentials" :class="item.series === '1+x证书'?'Xcertificate':'qualification'">
                    <span :style="{'color':item.series === '1+x证书'?'#83ABFE':'#05c0c2'}">{{item.certificateName}}</span>
                  </div>
                  <div class="credentialsMessage">
                    <dl>
                      <dt>{{item.certificateName}}</dt>
                      <dd>证书热度：<span>
                          <i class="heatIcon heat_icon" v-for="(e,i) in Number(item.hotNum)" :key="i"></i>
                        </span></dd>
                      <dd>发布年份：<span>{{item.publishYear}}年</span></dd>
                      <dd>发布批次：<span>{{item.batch}}</span></dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <el-button class="seeMore_button" @click="seeMore" v-if="cacheCertificateList.length > 5">
              <span v-if="cacheCertificateList.length > certificateList.length">查看更多......</span>
              <span v-else>收起</span>
            </el-button>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      information: {  //基本信息
      },
      resourceLibrary: [], //专业资源库
      formInSearch: {
        certificateNameBody: '',
      },
      certificateList: [],  //专业证书
      cacheCertificateList: [], //缓存专业证书
    }
  },
  created() {
    this.getProfessionInfo() // 获取基本信息、培养目标和可从事岗位
    this.getCertificateInfo()
    this.certificateDom()
  },
  methods: {
    // 获取基本信息、培养目标和可从事岗位
    getProfessionInfo() {
      this.$axios.post(this.$apiurls.essential_getProfessionalReceptionMajor, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.information = res.data.responseBody.data
          this.information.professionalFace = this.information.professionalFace.split('、')
        }
      });
    },

    // 获取专业资源库
    getCertificateInfo() {
      var time = new Date;
      var datatime = time.getFullYear() + (time.getMonth() + 1 > 9 ? String(time.getMonth() + 1) : '0' + (time.getMonth() + 1))
      this.$axios.post(this.$apiurls.essential_getZykMonthRank, datatime, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.resourceLibrary = res.data
        }
      });
    },
    // 轮播图切换
    toggleUpper() {
      this.$refs.rotation.prev()
    },
    toggleLower() {
      this.$refs.rotation.next()
    },
    // 轮播图跳转
    jump(url) {
      window.open(url)
    },

    //专业证书
    certificateDom() {
      this.$axios.post(this.$apiurls.essential_getCertificateInfo, this.formInSearch.certificateNameBody, {
        loading: false,
      }).then((res) => {
        this.certificateList = []
        for (let i = 0; i < res.data.length; i++) {
          if (i < 5) {
            this.certificateList.push(res.data[i])
          }
        }
        this.cacheCertificateList = res.data
      });
    },
    // 查看更多
    seeMore() {
      if (this.certificateList.length >= this.cacheCertificateList.length) {
        this.certificateList = []
        for (let i = 0; i < this.cacheCertificateList.length; i++) {
          if (i < 5) {
            this.certificateList.push(this.cacheCertificateList[i])
          }
        }
      } else {
        var lengthValue = this.certificateList.length - 1
        for (let i = lengthValue; i < lengthValue + 5; i++) {
          this.certificateList.push(this.cacheCertificateList[i])
        }
      }
    },
    // 查看专业证书pdf
    downloads(fileId, fileName) {
      // window.open(`${this.$apiurls.essential_previewCertificate}?fileId=${fileId}`)
      window.open("http://101.201.126.223:9006/lrmv2_file/certificate/" + fileName + ".pdf")
    }
  }
}
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" scoped>
.page .distribution {
  height: 420px;
  position: relative;
  margin-bottom: 12px;
}

.page .distribution:last-child {
  margin-bottom: 0px;
}

.page .middle {
  height: 450px;
}

.dataSources {
  height: 100%;
}

// 内容盒子
.pictureCharts-box {
  overflow: hidden;
  height: 350px;
  padding: 0 !important;
}

.tag-box,
.project-box,
.pictureCharts-box {
  position: relative;
  padding: 15px 20px;
  P {
    margin: 0;
    padding: 0;
  }
  .el-tag {
    background: rgba(31, 59, 109, 0.39);
    color: #348be7;
    border: none;
  }
  .custom-tag {
    width: calc(25% - 4px);
    min-height: 32px;
    line-height: 32px;
    font-size: 14px;
    display: inline-block;
    border-radius: 4px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    float: left;
  }
  .custom-tag:nth-child(even) {
    background: rgba(255, 255, 255, 0.04);
    color: #999;
    text-indent: 15px;
  }
  .custom-tag:nth-child(odd) {
    background: rgba(29, 50, 94, 0.39);
    color: #fff;
    text-align: center;
  }
  .lineHeight {
    line-height: 30px;
  }
}

// 专业资源库
.el-carousel {
  height: 100%;
}

.el-carousel__container .el-carousel__item {
  width: 90%;
  display: flex;
  margin-left: 5%;
}

.rotationLayout {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 31%;
  height: 100%;
  margin: 0px auto;
}

.smallBox {
  width: 100%;
  height: 80%;
  display: flex;
  align-items: center;
  flex-flow: column;
  margin: 0px auto;
}

.casket {
  width: 100%;
  height: 55%;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: #fff;
  text-align: center;
}

.casket span {
  padding: 0px 20px;
  font-size: 1.2rem;
  font-weight: 700;
}

.mainInformation dl {
  margin: 5px 0px 0px;
}

.mainInformation dl dt {
  text-align: center;
  padding: 0px 20px 10px;
  font-size: 0.8rem;
  color: #687592;
}

.mainInformation dl dd {
  margin-left: 10px;
  font-size: 0.6rem;
  line-height: 25px;
  color: #348be7;
  display: flex;
}

.mainInformation dl dd > span {
  color: #81ace1;
}

.mainInformation dl dd .ascend {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ccc;
  margin-left: 2px;
  font-size: 10px;
}
.mainInformation dl dd .ascend i {
  font-size: 20px;
}
.mainInformation dl dd .ascend span {
  display: inline-block;
}

.rise {
  width: 8px;
  height: 20px;
  display: inline-block;
  background-size: 100% 100%;
  margin-right: 5px;
}

.decline {
  width: 8px;
  height: 20px;
  display: inline-block;
  background-size: 100% 100%;
  margin-right: 5px;
}

.risea {
  color: #f63a93;
}
.declinea {
  color: #00fe7e;
}

// 轮播图切换
.toggleArrowLeft {
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 1%;
  transform: translateY(-50%);
}
.toggleArrowRight {
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 95%;
  transform: translateY(-50%);
}

.standards_content ::v-deep .el-carousel__indicators--horizontal {
  width: 90%;
  text-align: center;
}

.standards_content
  ::v-deep
  .el-carousel__indicator.el-carousel__indicator--horizontal
  .el-carousel__button {
  background: #05080f;
  height: 3px;
  width: 100%;
  border-radius: 5px;
}

.standards_content
  ::v-deep
  .el-carousel__indicator.el-carousel__indicator--horizontal {
  width: calc(100% - 98%) !important;
}

.standards_content
  ::v-deep
  .el-carousel__indicator.el-carousel__indicator--horizontal.is-active
  .el-carousel__button {
  background: #1bacac;
}

// 专业证书搜索
.table-search-box {
  margin: 10px 0px 0px 30px;
}
.page .el-col.occupation {
  height: auto;
}

.certificate_box {
  width: 98%;
  margin: 0px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.professional_box {
  width: 18%;
  height: 300px;
  padding: 10px 15px;
  font-size: 30px;
}
.professional_box:last-child {
  margin-right: auto;
}

.professional_smallBox {
  width: 100%;
  height: 100%;
}

.credentials {
  width: 100%;
  height: 55%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.credentials span {
  padding: 0px 20px;
  font-size: 1.3rem;
  font-weight: 700;
  // color: #83abfe;
  text-shadow: #1e2449 3px 2px 4px;
}

.credentialsMessage dl {
  margin: 5px 0px 0px;
}

.credentialsMessage dl dt {
  text-align: center;
  padding: 0px 20px 5px;
  font-size: 0.8rem;
  color: #8897b5;
}

.credentialsMessage dl dd {
  margin-left: 10px;
  font-size: 0.8rem;
  line-height: 25px;
  color: #348be7;
  display: flex;
}

.credentialsMessage dl dd > span {
  color: #81ace1;
}

.seeMore_button {
  margin: 20px auto;
  font-size: 20px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background: transparent;
  border-width: 0px;
  color: #4d516c;
}

.seeMore_button :hover {
  color: #4d516c;
}

.heatIcon {
  width: 14px;
  height: 14px;
  display: inline-block;
  background-size: 100% 100%;
  margin-left: 5px;
}

// 通用样式
.weight {
  font-weight: bold;
}

.white {
  color: #fff !important;
}

.grey {
  color: #999 !important;
  font-size: 16px;
}

.cyan {
  color: #3b86ff;
  font-size: 16px;
}

.cyans {
  font-weight: bold;
  font-size: 16px;
  color: #1bf6f8;
}

.greys {
  font-weight: 700;
  font-size: 16px;
}

.indent {
  padding-left: 15px;
}

.size14 {
  font-size: 14px;
}

.mr-2 {
  margin-right: 2px !important;
}

.mt-2 {
  margin-top: 2px !important;
}

.mr-10 {
  margin-right: 10px !important;
}

.mt-10 {
  margin-top: 10px !important;
  display: "";
  verical-align: middle;
  white-space: pre-wrap;
}

.mt-30 {
  margin-top: 30px !important;
}

@media (max-width: 600px) {
  .hide {
    display: none !important;
  }
}
</style>
